import * as Popover from "@radix-ui/react-popover";
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";
import { useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

export default function DatePicker({ value, onChange, side = "rigtt" }) {
    const [open, setOpen] = useState(false);

    return (
        <Popover.Root open={open} onOpenChange={setOpen}>
            <Popover.Trigger asChild>
                <button className="flex h-12 w-full items-center justify-between rounded-lg border px-4 text-sm bg-white">
                    {value ? format(value, "PPP") : "Pick a date"}
                    <CalendarIcon size={18} className="text-gray-500" />
                </button>
            </Popover.Trigger>

            <Popover.Portal>
                <Popover.Content
                    side={side}
                    align="start"
                    sideOffset={6}
                    collisionBoundary="viewport"
                    collisionPadding={20}
                    avoidCollisions={true}
                    sticky="always"
                    className="z-50 rounded-lg border bg-white p-2 shadow-xl"
                >
                    <div className="max-h-[80vh] overflow-auto">
                        <DayPicker
                            mode="single"
                            selected={value}
                            fromDate={new Date()}
                            onSelect={(date) => {
                                onChange(date);
                                setOpen(false);
                            }}
                        />
                    </div>
                </Popover.Content>
            </Popover.Portal>
        </Popover.Root>
    );
}